<template>
  <div>
    <signature-layout 
      :submitSignature="sign"
      :signatureId="signatureId"
      :isLoading="isLoading"
      :foundRequest="found"
      :errorMessage="errorMessage"
      :workflowGuid="registration.workflowGuid"
      :submittedAt="registration.submittedAt"
    >
      <span slot="subtitle">
        Registration Application
      </span>
      <span slot="title">Affiliate Registration</span>
      <div slot="approvedContent" v-if="registration.affiliateRequestData && registration.affiliateRequestData.affiliateName">
        <div class="mt-5">                    
          <h2>
            <b>{{ registration.affiliateRequestData.affiliateName }}</b>
          </h2>
          <h3 class="mt-5">
            <span><b>Address: </b></span>
            <span>{{ registration.affiliateRequestData.affAddress.street }}, {{ registration.affiliateRequestData.affAddress.city }}, {{ registration.affiliateRequestData.affAddress.state }} {{ registration.affiliateRequestData.affAddress.zip }}, {{ registration.affiliateRequestData.affAddress.country }}</span>
          </h3>  
          <h3 class="mt-5">
            <span><b>Website: </b></span>
            <a class="no-text-decoration" :href="registration.affiliateRequestData.affiliateWebsite" target="_blank">
              {{ registration.affiliateRequestData.affiliateWebsite }}
            </a>
          </h3>
          <div class="mt-5">
            <h2>Club members:</h2>
            <p>
              <v-simple-table fixed-header :height="(registration.affiliateRequestData && registration.affiliateRequestData.affMembers) ? Math.min(200, (registration.affiliateRequestData.affMemberslength + 2) * 50) : 100">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Position</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Membership ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="member in registration.affiliateRequestData.affMembers" :key="member.personId">
                      <td>{{ member.position }}</td>
                      <td>{{ member.firstName }} {{ member.lastName }}</td>    
                      <td>{{ member.memberId }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </p>
          </div>
          <div class="mt-5">
            <p>
              ASCA has adopted and is using the trademarks: ASCA&reg;, Australian Shepherd Club of America, Aussie Times,
              and the Australian Shepherd Dog Bust Logo. Licensee acknowledges the validity of ASCA's title to these marks
              and agrees not to contest such title. Licensee wishes to use the following of these marks:
            </p>
            <p>                          
              <v-checkbox v-for="trademark in registration.affiliateRequestData.selectedBrandTrademarks" v-bind:key="trademark.id"
                :label="trademark.affiliateRequestData.description"
                v-model="trademark.affiliateRequestData.selected"
                readonly
                dense
                />
            </p>
            <p>In consideration of the mutual promises contained in this license, ASCA grants to Licensee a non-exclusive,
                revocable right the use the mark(s) checked above solely in conjunction with:</p>
            <p>                           
              <v-checkbox  v-for="trademark in registration.affiliateRequestData.selectedEventsTrademarks" v-bind:key="trademark.id"
                :label="trademark.description"
                v-model="trademark.selected"
                readonly
                dense
              />
            </p>
            <p>ASCA may revoke this license at any time in its absolute and sole discretion. Unless revoked, this license
                remains in effect on annual affiliate renewals.</p>
          </div>
        </div>
      </div>        
      <div slot="legalText">
        <p class="bottom-text">
            We the undersigned, apply for membership renewal to the Australian Shepherd Club of America as Affiliate
            Officers of the above named club. As official representatives of that affiliate, we agree that our club will abide
            by the <ASCAArtIncLink />, <BylawsLink />, Dispute Rules, ASCA Registry Rules and all ASCA programs.
        </p>
      </div>
    </signature-layout>
  </div>    
</template>

<script lang="ts">
import Vue from "vue";
import SignatureLayout from "@/components/common/SignatureLayout.vue";
import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
import BylawsLink from "@/components/common/BylawsLink.vue";

import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";

export default Vue.extend({
  name: 'AffiliateRegistrationSignatureForm',
  components: {
    SignatureLayout,
    ASCAArtIncLink,
    BylawsLink,
  },
  props: { signatureId: Number },
  data: function() {
    return {
      signatureText: "",
      errorMessage: "",
      registration: Object,
      isLoading: false,
      found: false,
    };
  },
  created() {
    this.load();
  },
  watch: {
    signatureId: function (newValue) { this.load(); }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    load: async function () {
      this.isLoading = true;

      const response = await workflowService.getAffiliateRegistrationDetailsForSignature(this.signatureId);

      this.errorMessage = "";
      this.found = response.found;

      if (response.found && (!response.errors || response.errors.length == 0)) {
        this.registration = response.data;
      } else if (!!response.errors) this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured'

      this.isLoading = false;
    },
    sign: function(workflowGuid: String, signatureId: number, personId: number, text: String) {
      workflowService.
        signAffiliateRegistration(workflowGuid, signatureId, personId, text)
        .then(res => {
          this.$store.dispatch("loadPersonTasks", this.userInfo.personId);
          this.$router.push('/');
        }).catch(this.$handleError);
    }
  },
});
</script>
